export default "__VITE_ASSET__BjOmmeq5__"